<template>
  <grey-tabs v-model="currentTab" :tabs="tabs" has-tabs-tools has-border :height="35" :tabsClasses="['pt-6', 'pl-6']">
    <v-tab-item>
      <style-dialog-style-tab
        :is-valid.sync="isStyleValid"
        :layerStyle.sync="computedLayerStyle"
        :geometry-type="geometryType"
        :symbolization-kind="symbolizationKind"
        :symbolization-type="symbolizationType"
      />
    </v-tab-item>
    <v-tab-item>
      <style-dialog-labels-tab
        :is-valid.sync="isLabelsValid"
        :attributes="attributes"
        :labelsStyle="computedLayerStyle.labels"
        :symbolization-type="symbolizationType"
      />
    </v-tab-item>
    <template #tabsTools>
      <v-col cols="auto" class="pt-6 pb-0">
        <dots-menu :items="tabsToolsMenuItems" @exportStyle="exportStyle" @importStyle="importStyle">
          <template #importStyle.title>
            <v-list-item style="min-height: 30px">
              <file-input ref="styleImportFile" :options="styleImportOptions" @fileAdded="importStyle">
                <template #uploadContent>
                  <v-list-item-title
                    class="text-item text-left text-subtitle-2 font-weight-regular"
                    style="cursor: pointer"
                    v-text="$i18n.t('menu.importStyle')"
                  >
                  </v-list-item-title>
                </template>
              </file-input>
            </v-list-item>
          </template>
        </dots-menu>
      </v-col>
    </template>
  </grey-tabs>
</template>
<script>
import DotsMenu from '@/components/DotsMenu';
import FileInput from '@/components/FileInput';
import GreyTabs from '@/components/GreyTabs';
import StyleDialogLabelsTab from '@/components/StyleDialogLabelsTab';
import StyleDialogStyleTab from '@/components/StyleDialogStyleTab';
export default {
  name: 'StyleDialogStyleTabs',
  components: {
    DotsMenu,
    FileInput,
    GreyTabs,
    StyleDialogLabelsTab,
    StyleDialogStyleTab,
  },
  props: {
    attributes: {
      type: Array,
      default: () => {
        return [];
      },
    },
    geometryType: {
      type: String,
      required: true,
    },
    isValid: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    layerName: {
      type: String,
      required: true,
    },
    layerStyle: {
      type: Object,
      default: () => {
        return {};
      },
    },
    symbolizationKind: {
      type: String,
    },
    symbolizationType: {
      type: String,
    },
  },
  computed: {
    computedLayerStyle: {
      get() {
        return this.layerStyle;
      },
      set(nV) {
        this.$emit('update:layerStyle', nV);
      },
    },
    styleImportOptions() {
      return {
        url: '/',
        autoProcessQueue: false,
        maxFiles: 1,
        acceptedFiles: '.aq3',
      };
    },
    tabs() {
      return [{ name: this.$i18n.t('dialog.style.style') }, { name: this.$i18n.t('dialog.style.labels') }];
    },
    tabsToolsMenuItems() {
      return [
        {
          name: 'exportStyle',
          disabled: !this.isValid,
        },
        {
          name: 'importStyle',
        },
      ];
    },
  },
  data: () => ({
    currentTab: 0,
    isLabelsValid: true,
    isStyleValid: false,
  }),
  methods: {
    exportStyle() {
      this.$emit('export');
    },
    importStyle(file) {
      const styleCopy = JSON.parse(JSON.stringify(this.computedLayerStyle));
      let reader = new FileReader();
      reader.addEventListener('loadend', event => {
        try {
          const text = event.target.result;
          const jsonObject = JSON.parse(text);
          this.$emit('import', jsonObject);
        } catch {
          this.$emit('import', styleCopy);
        }
      });
      reader.readAsText(file);
      this.$refs.styleImportFile.$refs.dropzone.removeAllFiles();
    },
  },
  watch: {
    isLabelsValid(nV) {
      this.$emit('update:isValid', nV && this.isStyleValid);
    },
    isStyleValid(nV) {
      this.$emit('update:isValid', nV && this.isLabelsValid);
    },
    //Fix dla styli zapisanych w starej strukturze
    computedLayerStyle: {
      immediate: true,
      deep: true,
      handler(nV) {
        if (!nV.labels || Array.isArray(nV.labels)) {
          this.$set(this.computedLayerStyle, 'labels', {});
        }
      },
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep {
  .v-tabs {
    position: unset !important;
  }
  .v-slide-group {
    box-shadow: none !important;
  }
  .v-tab {
    border-top: 1px solid rgba(0, 0, 0, 0.12) !important;
    border-bottom: 1px solid rgba(0, 0, 0, 0.12) !important;
  }
}
.v-window-item {
  padding-top: 20px !important;
}
</style>
